export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-thumbnails-34e7f937f2ecf9e7b544f5a20538947c.svg";